module.exports = __webpack_public_path__ + "assets/img/share-bg.01594d7a.png";